import React from 'react';
import {connect} from 'react-redux';
import {parse, isSameDay, addMinutes} from 'date-fns';

import DifferentDayWarning from './DifferentDayWarning';
import AdvanceReservationWarning from './AdvanceReservationWarning';
import MaxWalkExceededWarning from './MaxWalkExceededWarning';

// TODO: Refactor -- component is handling too many responsibilities
class TripWarnings extends React.Component {

    tripRequiresAdvanceReservation(trip) {
        let requiresReservation = false;
        trip.legs.forEach(leg => {
            if ((leg.from.boardAlightType === 'DEVIATED') || (leg.to.boardAlightType === 'DEVIATED')) {
                requiresReservation = true;
            }
        });
        return requiresReservation;
    }

    tripExceedsMaxWalking(trip) {
        let exceedsWalking = false;
        trip.legs.forEach(leg => {
            if (leg.walkLimitExceeded) {
                exceedsWalking = true;
            }
        });
        return exceedsWalking;
    }

    tripIsDifferentDay(trip) {
        const requestStart = parse(this.props.requestDate);
        const agencyOffset = (trip.legs[0].agencyTimeZoneOffset) / (60 * 1000);
        const today = new Date();
        const timezoneDiff = agencyOffset + today.getTimezoneOffset();
        const tripStart = addMinutes(parse(trip.startTime), timezoneDiff);
        return !isSameDay(tripStart, requestStart);
    }

    getWarningsForTrip(trip, isSummary=false) {
        let warnings = [];
        if (this.tripIsDifferentDay(trip)) {
            warnings.push(<DifferentDayWarning
                key="differentDayWarning"
                isSummary={isSummary}
            />);
        }
        if (this.tripRequiresAdvanceReservation(trip)) {
            warnings.push(<AdvanceReservationWarning
                key="advanceReservationWarning"
                isSummary={isSummary}
            />);
        }
        if (this.tripExceedsMaxWalking(trip)) {
            warnings.push(<MaxWalkExceededWarning
                key="maxWalkExceededWarning"
                isSummary={isSummary}
            />);
        }
        return warnings;
    }

    getWarningsForTrips() {
        let warnings = this.props.trips.map(trip => {
            return this.getWarningsForTrip(trip, true);
        });
        warnings = [].concat(...warnings);
        let removeDups = warnings.reduce((acc, curr) => {
            if (acc.find(warning => warning.key === curr.key)) {
                return [...acc];
            } else {
                return [...acc, curr];
            }
        }, []);
        return removeDups;
    }

    isSummaryOfAllTrips() {
        return (this.props.trips.length > 0);
    }

    renderAllTripsWarningSummary() {
        const warnings = this.getWarningsForTrips();
        if (warnings.length === 0) {
            return <div></div>;
        }
        return (
            <div className="otp-warning-legend">
                {warnings}
            </div>
        );
    }

    renderSingleTripWarnings() {
        const warnings = this.getWarningsForTrip(this.props.trip);
        if (warnings.length === 0) {
            return <div></div>;
        }
        return (
            <span className="otp-trip-warnings">
                {warnings}
            </span>
        );
    }

    render() {
        if (this.isSummaryOfAllTrips()) {
            return this.renderAllTripsWarningSummary();
        } else {
            return this.renderSingleTripWarnings();
        }
    }
}

TripWarnings.defaultProps = {
    trips: []
};


const mapStateToProps = state => {
    return {
        requestDate: state.form.fields.date.value,
    };
};
// console.log(mapStateToProps);

export default connect(mapStateToProps)(TripWarnings);